import { AffLinkWithRevenue } from './AffLink'
import { CouponWithPayments } from './Coupon'

export enum PaymentTypeEnum {
  Coupon = 'Coupon',
  Shipments = 'Shipments',
  Giftcard = 'Giftcard',
}
export interface AffPayment {
  type: PaymentTypeEnum
  date: string
  payment: string
}

export interface Affiliate {
  affLinks: { code: string }[]
  user: {
    name: string
    email: string
    familyName: string
  }
  rev: number
  pkgIncomeOffset: number
  couponIncomeOffset: number
  isOnHold?: boolean
  registeredUsers: number
  paymentGiftCards: number
  paymentsHistory: AffPayment[]
  id: string
  userId: string
  updatedAt: string
  createdAt: string
}

export interface AffUserData extends Affiliate {
  coupons: CouponWithPayments[]
  pkgIncome: number
  affLinks: AffLinkWithRevenue[]
}
